import { memo } from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

export type ItemPickerNavBarProps = {
  canGoBack: boolean;
  canGoForward: boolean;
  label: string;
  onBack: () => void;
  onForward: () => void;
};

export const ItemPickerNavBar = memo(({ canGoBack, canGoForward, label, onBack, onForward }: ItemPickerNavBarProps) => {
  return (
    <div className="flex shrink-0 items-center gap-1 ads:border-default border-gray-4 border-b px-4 py-2">
      <IconButton
        adsIcon
        appearance="ghost"
        color="gray"
        data-testid="ITEM_PICKER_BACK"
        disabled={!canGoBack}
        icon={ChevronLeftIcon}
        label="Go back"
        onClick={onBack}
        size="small"
        type="button"
      />
      <IconButton
        adsIcon
        appearance="ghost"
        color="gray"
        data-testid="ITEM_PICKER_FORWARD"
        disabled={!canGoForward}
        icon={ChevronRightIcon}
        label="Go forward"
        onClick={onForward}
        size="small"
        type="button"
      />
      <span className="ml-1 font-medium ads:text-primary text-12 text-gray-12" data-testid="ITEM_PICKER_NAV_LABEL">
        {label}
      </span>
    </div>
  );
});

ItemPickerNavBar.displayName = 'ItemPickerNavBar';
